import { Signal, computed } from '@angular/core';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { ICustomReportFilter } from '@principle-theorem/principle-core/interfaces';
import { CustomReportFilter } from '@principle-theorem/reporting';
import { ITimePeriod } from '@principle-theorem/shared';
import * as moment from 'moment-timezone';

export interface IDateFormData {
  date?: moment.Moment;
  dateFrom?: moment.Moment;
  dateTo?: moment.Moment;
}

export class CustomReportDatePickers {
  formGroup = new TypedFormGroup<IDateFormData>({
    date: new TypedFormControl<moment.Moment>(moment()),
    dateFrom: new TypedFormControl<moment.Moment>(moment().startOf('day')),
    dateTo: new TypedFormControl<moment.Moment>(moment().endOf('day')),
  });
  dateFilters: Signal<ICustomReportFilter[]>;
  dateRangeFilters: Signal<ICustomReportFilter[]>;
  hasDateFilters: Signal<boolean>;

  constructor(filters: Signal<ICustomReportFilter[]>) {
    this.dateFilters = computed(() =>
      filters().filter((filter) => CustomReportFilter.isDateFilter(filter))
    );
    this.dateRangeFilters = computed(() =>
      filters().filter((filter) => CustomReportFilter.isDateRangeFilter(filter))
    );
    this.hasDateFilters = computed(
      () => [this.dateFilters(), this.dateRangeFilters()].flat().length > 0
    );
  }

  setDateRange(event: ITimePeriod): void {
    this.formGroup.patchValue({ dateFrom: event.from, dateTo: event.to });
  }
}
